import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useEffect, useMemo, useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import { PracticeDetailVM } from 'practice/view-models/practice-detail';
import { AccordionSummary as MuiAccordionSummary, AccordionSummaryProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import ExceptionTables from 'practice/components/shared/exception-tables';

type CustomAccordionSummaryProps = AccordionSummaryProps & { hasError?: boolean };

export const AccordionSummary = styled((props: CustomAccordionSummaryProps) => (
  <MuiAccordionSummary {...props} />
))(({ theme, hasError }) => ({
  backgroundColor: hasError
    ? theme.palette.mode === 'dark'
      ? theme.palette.cdmBrand.main
      : theme.palette.cdmBrand.main
    : theme.palette.mode === 'dark'
    ? 'rgba(255, 255, 255, .05)'
    : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  color: hasError ? 'white' : undefined,
  '&:hover': {
    background: hasError
      ? 'linear-gradient(-45deg, #d6012e 0%, #e12f4c 15%, #ba001f 15%, #f0475b 35%, #c11a33 85%, #910015 100%)'
      : 'linear-gradient(-45deg, #e7e6e6 0%, #fafafa 15%, #e0dfdf 15%, #fff 35%, #eeebeb 85%,#dad8d8 100%)',
  },
  minHeight: 'auto !important',
  '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
    margin: `10px 5px`,
  },
}));

const AccordionExceptionListComponent = (): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<PracticeDetailVM>();

  useEffect(() => {
    if (
      formContext.values.exceptionList?.body &&
      formContext.values.exceptionList?.body?.length > 0
    ) {
      setOpen(true);
    }
  }, [formContext.values.exceptionList?.body]);

  const eccezioniIgnorabili = useMemo(
    () => formContext.values.exceptionList?.body?.filter((el) => el.eccezioneIgnorabile) || [],
    [formContext.values.exceptionList?.body]
  );

  const eccezioniAnpr = useMemo(
    () => formContext.values.exceptionList?.body?.filter((el) => !el.eccezioneIgnorabile) || [],
    [formContext.values.exceptionList?.body]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="accordion-exception-list-content"
        id="accordion-exceptino-list-header"
        expandIcon={
          <ExpandMore
            sx={{
              color:
                formContext.values.exceptionList?.body &&
                formContext.values.exceptionList?.body?.length > 0
                  ? 'white'
                  : undefined,
            }}
          />
        }
        hasError={
          formContext.values.exceptionList?.body &&
          formContext.values.exceptionList?.body?.length > 0
        }
      >
        <Typography>Elenco eccezioni</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ExceptionTables eccezioniIgnorabili={eccezioniIgnorabili} eccezioniAnpr={eccezioniAnpr} />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionExceptionListComponent.displayName = 'Practice State - Table - accordion practice state';

const AccordionExceptionList = memo(AccordionExceptionListComponent);

export default AccordionExceptionList;
